<template>
  <div id="Logistics">
    <van-cell-group>
      <van-cell style="color:#999;">
        <div style="text-align:center;">
          运单号：<span class="high-light">{{ trackingNumber }}</span>
          <div v-show="beginOrganName || endOrganName">
            <span class="high-light">{{ beginOrganName }}</span> ->
            <span class="high-light">{{ endOrganName }}</span>
          </div>
        </div>
      </van-cell>
      <div style="font-size: 0.375rem;padding: 0.25rem;">
        <span style="color: red;">当前位置：</span>{{ carLocation }}
      </div>
    </van-cell-group>
    <div id="allmap" :class="{ fullScreen: fullMap }" v-show="mapShow"></div>
    <van-steps
      class="step-list"
      direction="vertical"
      :active="active"
      active-color="#0b92e6"
    >
      <van-step v-for="(item, index) in recordList" :key="index">
        <h3 class="step-title" v-if="item.status === 11">包裹已被取消</h3>

        <h3 class="step-title" v-else-if="item.status === 10">
          <a :href="'tel:' + item.prevStation.phone" class="high-light"
            >已签收，感谢使用{{
              item.nextStation.name || ""
            }}，欢迎再次为您服务！</a
          >
        </h3>

        <h3 class="step-title" v-else-if="item.status === 9">
          包裹已由配送员<a :href="'tel:' + item.phone" class="high-light"
            >[{{ item.name }}]</a
          >送达目的地（联系电话：<a
            :href="'tel:' + item.phone"
            class="high-light"
            >{{ item.phone }}</a
          >）
        </h3>

        <h3 class="step-title" v-else-if="item.status === 8">
          <a :href="'tel:' + item.prevStation.phone" class="high-light">{{
            item.prevStation.name
          }}</a
          >配送员<a :href="'tel:' + item.phone" class="high-light">{{
            item.name
          }}</a
          >正在配送（联系电话：<a
            :href="'tel:' + item.phone"
            class="high-light"
            >{{ item.phone }}</a
          >）
        </h3>

        <h3 class="step-title" v-else-if="item.status === 7">
          包裹到达<a :href="'tel:' + item.prevStation.phone" class="high-light"
            >[{{ item.prevStation.name }}]</a
          >
        </h3>

        <h3 class="step-title" v-else-if="item.status === 6">
          包裹在<a :href="'tel:' + item.prevStation.phone" class="high-light"
            >[{{ item.prevStation.name }}]</a
          >发往<a :href="'tel:' + item.nextStation.phone" class="high-light"
            >[{{ item.nextStation.name }}]</a
          >
        </h3>

        <h3 class="step-title" v-else-if="item.status === 5">
          包裹正在<a :href="'tel:' + item.prevStation.phone" class="high-light"
            >[{{ item.prevStation.name }}]</a
          >扫描装车中！准备发往下一站
        </h3>

        <h3 class="step-title" v-else-if="item.status === 4">
          包裹已到达<a
            :href="'tel:' + item.prevStation.phone"
            class="high-light"
            >[{{ item.prevStation.name }}]</a
          >
        </h3>

        <h3 class="step-title" v-else-if="item.status === 3">
          包裹已从<a :href="'tel:' + item.prevStation.phone" class="high-light"
            >[{{ item.prevStation.name }}]</a
          >发往<a :href="'tel:' + item.nextStation.phone" class="high-light"
            >[{{ item.nextStation.name }}]</a
          >
        </h3>

        <h3 class="step-title" v-else-if="item.status === 2">
          包裹已由<a :href="'tel:' + item.prevStation.phone" class="high-light"
            >[{{ item.prevStation.name }}]</a
          >开单受理
        </h3>

        <h3
          class="step-title"
          v-else-if="item.status === 1 && item.statusName === '待开单'"
        >
          配送员<a :href="'tel:' + item.phone" class="high-light"
            >[{{ item.name }}]</a
          >完成揽件
        </h3>

        <h3
          class="step-title"
          v-else-if="item.status === 1 && item.statusName !== '待开单'"
        >
          配送员<a :href="'tel:' + item.phone" class="high-light"
            >[{{ item.name }}]</a
          >正在前往提货
        </h3>

        <h3 class="step-title" v-else-if="item.status === 0">
          商户<a :href="'tel:' + item.phone" class="high-light"
            >[{{ item.name }}]</a
          >已下单
        </h3>

        <p class="step-time">{{ item.date }}</p>
        <p style="color: red" v-if="item.classes">
          班次号：{{ item.classes }}
        </p>
      </van-step>
    </van-steps>
    <div
      style="background-color:#fff;padding: 0.35rem;text-align: center;font-size: 0.4rem; color: #666;"
    >
      温馨提示：点击站点名称可拨打站点电话
    </div>
    <div class="code">
      <img src="../../assets/QR_Code.jpg" />
      <div>长按关注”云企物流“</div>
      <div>实时接收货物信息推送</div>
    </div>
  </div>
</template>

<script>
import { Dialog } from "vant";

export default {
  name: "Logistics",
  data() {
    return {
      beginLat: null,
      beginLng: null,
      endLat: null,
      endLng: null,
      beginOrganName: "",
      endOrganName: "",
      recordList: [],
      carLocation: "",
      fullMap: false,
      searchKey: "",
      active: 0,
      trackingNumber: "",
      mapShow: false,
      BMap: null
    };
  },
  mounted() {
    if (this.$route.query.id) {
      this.onSearch(this.$route.query.id);
    }
  },
  methods: {
    clickMap() {
      let that = this;
      this.fullMap = !this.fullMap;
      if (this.fullMap) {
        // eslint-disable-next-line
        function BackControl() {
          this.defaultAnchor = BMAP_ANCHOR_TOP_LEFT;
          this.defaultOffset = new BMap.Size(10, 10);
        }

        BackControl.prototype = new BMap.Control();
        // eslint-disable-next-line
        BackControl.prototype.initialize = function(map) {
          that.div = document.createElement("div");
          that.div.appendChild(document.createTextNode("返回查询"));
          that.div.style.cursor = "pointer";
          that.div.style.border = "1px solid #ddd";
          that.div.style.background = "#fff";
          that.div.style.fontSize = "0.375rem";
          that.div.style.padding = "0.25rem";
          that.div.onclick = that.clickMap;
          that.BMap.getContainer().appendChild(that.div);
          return that.div;
        };
        let backControl = new BackControl();
        this.BMap.addControl(backControl);
        this.BMap.removeEventListener("click", this.clickMap);
      } else {
        this.BMap.removeControl(that.div);
        this.BMap.addEventListener("click", this.clickMap);
      }
    },

    /**
     * 绘制坐标
     * @param {Object} point 坐标 {lat,lng}
     * @param {String} text 坐标提示
     * @param {String} type 坐标类型
     * @param {Number} left 偏移
     * @param {Number} top 偏移
     */
    drawPoint(point, text, type) {
      let that = this;
      point = new BMap.Point(point.lng, point.lat);

      function customOverlay(_point, _text) {
        this._point = _point;
        this._text = _text;
      }

      customOverlay.prototype = new BMap.Overlay();
      customOverlay.prototype.initialize = function(map) {
        this._map = map;
        let div = (this._div = document.createElement("div"));
        div.style.position = "absolute";
        if (type !== "car") {
          let iconSpan = document.createElement("span");
          let textSpan = document.createElement("span");
          div.classList.add("start-icon");
          iconSpan.classList.add("icon");
          textSpan.classList.add("text");
          // 设置样式
          iconSpan.style.position = "absolute";
          iconSpan.style.left = "0";
          iconSpan.style.top = "-2px";
          iconSpan.style.display = "inline-block";
          iconSpan.style.width = "0.65rem";
          iconSpan.style.height = "0.73rem";
          iconSpan.style.zIndex = "2";
          textSpan.style.position = "absolute";
          textSpan.style.left = "0";
          textSpan.style.lineHeight = "0.62rem";
          textSpan.style.borderRadius = "0.31rem";
          textSpan.style.color = "#fff";
          textSpan.style.paddingLeft = "0.68rem";
          textSpan.style.paddingRight = "0.25rem";
          textSpan.style.width = "2rem";
          textSpan.style.zIndex = "1";
          if (type === "start") {
            iconSpan.style.background =
              "url(" +
              require("../../assets/map_point_start.png") +
              ") center / 100% no-repeat";
            textSpan.style.backgroundColor = "#20d3bd";
            textSpan.style.top = "0.08rem";
          } else {
            iconSpan.style.background =
              "url(" +
              require("../../assets/map_point_end.png") +
              ") center / 100% no-repeat";
            textSpan.style.backgroundColor = "#FF6566";
            textSpan.style.top = "0rem";
          }

          textSpan.appendChild(document.createTextNode(this._text));
          div.appendChild(iconSpan);
          div.appendChild(textSpan);
        } else {
          let infoWindow = document.createElement("div");
          let arrow = document.createElement("div");
          let arrow1 = document.createElement("span");
          let carIcon = document.createElement("div");

          // 设置样式
          div.style.position = "absolute";
          div.style.display = "flex";
          div.style.flexDirection = "column";
          div.style.alignItems = "center";
          div.style.width = "200px";
          infoWindow.style.padding = "0.25rem";
          infoWindow.style.position = "relative";
          infoWindow.style.left = "-3px";
          infoWindow.style.backgroundColor = "rgba(255,255,255,0.7)";
          infoWindow.style.border = "1px solid #FF995B";
          infoWindow.style.borderRadius = "3px";
          infoWindow.style.zIndex = "999";
          arrow.style.position = "absolute";
          arrow.style.bottom = "-10px";
          arrow.style.left = "50%";
          arrow.style.transform = "translateX(-50%)";
          arrow.style.border = "5px solid transparent";
          arrow.style.borderTopColor = "#FF995B";
          arrow1.style.position = "absolute";
          arrow1.style.border = "5px solid transparent";
          arrow1.style.borderTopColor = "#fff";
          arrow1.style.top = "-6px";
          arrow1.style.left = "-5px";
          carIcon.style.marginTop = "5px";
          carIcon.style.width = "45px";
          carIcon.style.height = "34px";
          carIcon.style.background =
            "url(" +
            require("../../assets/map_point_car.png") +
            ") center / 100% no-repeat";
          arrow.appendChild(arrow1);
          infoWindow.innerHTML = text;
          infoWindow.appendChild(arrow);
          div.appendChild(infoWindow);
          div.appendChild(carIcon);
        }
        // 加入到地图
        that.BMap.getPanes().labelPane.appendChild(div);
        return div;
      };
      customOverlay.prototype.draw = function() {
        let map = this._map;
        let pixel = map.pointToOverlayPixel(this._point);
        this._div.style.left = pixel.x + "px";
        if (type === "start") {
          this._div.style.top = pixel.y + "px";
        } else if (type === "end") {
          this._div.style.top = pixel.y - 30 + "px";
        } else {
          this._div.style.left = pixel.x - 95 + "px";
          this._div.style.top = pixel.y - 85 + "px";
        }
      };
      let myOverlay = new customOverlay(point, text);
      that.BMap.addOverlay(myOverlay);
    },

    /**
     * 绘制路径
     * @param {Array} pointArr 图标数组
     * @param {String} type 绘制类型
     */
    drawPath(pointArr, type) {
      let p1 = new BMap.Point(pointArr[0].lng, pointArr[0].lat);
      let p2 = new BMap.Point(pointArr[1].lng, pointArr[1].lat);
      let driving = new BMap.DrivingRoute(this.BMap);
      driving.search(p1, p2);
      driving.setSearchCompleteCallback(results => {
        let path = results
          .getPlan(0)
          .getRoute(0)
          .getPath();
        let color = type === "start" ? "#FF995B" : "#01BD4C";
        let polyline = new BMap.Polyline(path, {
          strokeColor: color,
          strokeWeight: 3,
          strokeStyle: "solid"
        });
        this.BMap.addOverlay(polyline);
      });
    },
    // 搜索
    onSearch(trackingNumber) {
      if (!trackingNumber) {
        Dialog.alert({
          title: "温馨提示",
          message: "请输入订单号"
        }).then(() => {
          return false;
        });
        return false;
      }
      this.trackingNumber = trackingNumber;
      this.recordList.splice(0, -1);
      this.getTracking(trackingNumber).then(data => {
        this.beginLat = data.beginLat;
        this.beginLng = data.beginLng;
        this.endLat = data.endLat;
        this.endLng = data.endLng;
        this.beginOrganName = data.beginOrganName;
        this.endOrganName = data.endOrganName;
        let beginPoint = { lat: this.beginLat, lng: this.beginLng };
        let endPoint = { lat: this.endLat, lng: this.endLng };
        this.recordList = data.recordList;
        let endStatus = data.recordList[0].status;
        let endNode = data.recordList[0];

        if (this.beginLat === 0 || !this.beginLat) return;
        if (this.endLat === 0 || !this.endLat) return;
        this.mapShow = true;
        this.BMap = new BMap.Map("allmap");
        this.BMap.centerAndZoom(
          new BMap.Point(beginPoint.lng, beginPoint.lat),
          11
        );
        this.BMap.setViewport([beginPoint, endPoint], {
          margins: [30, 0, 30, 0]
        });
        this.BMap.enableScrollWheelZoom(true);
        this.BMap.addEventListener("click", this.clickMap);

        if (endStatus === 6) {
          this.BMap.clearOverlays();
          this.drawPoint(beginPoint, this.beginOrganName, "start");
          this.drawPoint(endPoint, this.endOrganName, "end");
          this.BMap.setViewport([beginPoint, endPoint], {
            margins: [30, 0, 30, 0]
          });
          if (!endNode.imei) {
            this.drawPath([beginPoint, endPoint]);
            return;
          }
          this.getTrackingGps(endNode.imei).then(data => {
            let carPoint = { lat: data[0].lat, lng: data[0].lng };
            this.drawPath([carPoint, beginPoint], "start");
            this.drawPath([carPoint, endPoint], "end");
            let carText = `
              <p>车牌号：${endNode.plateNumber}</p>
              <p>当前时速：${data[0].speed}KM/小时</p>
            `;
            this.drawPoint(carPoint, carText, "car");
            let geoc = new BMap.Geocoder();
            geoc.getLocation(new BMap.Point(carPoint.lng, carPoint.lat), re => {
              this.carLocation = re.address;
            });
          });
        } else if (endStatus === 7) {
          // 到达目的站
          this.BMap.clearOverlays();
          this.drawPoint(endPoint, this.endOrganName, "end");
          this.BMap.setViewport([endPoint], {
            margins: [30, 0, 30, 0]
          });
        } else if (endStatus <= 5 || endStatus >= 8) {
          this.BMap.clearOverlays();
          this.drawPoint(beginPoint, this.beginOrganName, "start");
          this.BMap.setViewport([beginPoint], {
            margins: [30, 0, 30, 0]
          });
        }
      });
    },

    // 获取运单信息
    getTracking(trackingNumber) {
      return new Promise((resolve, reject) => {
        let params = {
          params: {
            trackingNumber
          }
        };
        this.$axios
          .post("tracking/sign/Logistics/information/tracking", params)
          .then(res => {
            if (res.data.code === 200) {
              resolve(res.data.data);
            } else {
              reject();
            }
          });
      });
    },

    // 获取车辆经纬度
    getTrackingGps(imeis) {
      return new Promise((resolve, reject) => {
        let params = {
          params: {
            imeis,
            account: "TSTK",
            password: "20180808"
          }
        };
        this.$axios.get("gps/tracking", params).then(res => {
          if (res.data.code === 200) {
            resolve(res.data.data);
          } else {
            reject();
          }
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
#Logistics {
  #allmap {
    width: 100%;
    height: 5rem;
    &.fullScreen {
      height: 20rem;
    }
  }
  .high-light {
    color: rgb(11, 146, 230);
  }
  .step-list {
    .step-title,
    .step-time {
      color: #999;
      font-size: 0.355rem;
    }
  }
  .code {
    width: 5rem;
    margin: 0.25rem auto;
    text-align: center;
    font-size: 0.375rem;
    img {
      width: 5rem;
    }
  }
}
</style>
